var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDollarCircle = function SvgDollarCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: ".8rem",
    height: ".8rem",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm.67 12.436v1.497H7.228v-1.377c-.973-.046-1.92-.322-2.47-.625l.431-1.699c.607.33 1.47.643 2.416.643.845 0 1.405-.33 1.405-.9 0-.551-.468-.9-1.552-1.268C5.906 8.184 4.84 7.458 4.84 6.044c0-1.295.9-2.296 2.453-2.59V2.076h1.423v1.277c.956.027 1.617.248 2.122.477l-.432 1.644C10.04 5.3 9.36 4.96 8.312 4.96c-.946 0-1.249.422-1.249.827 0 .468.505.79 1.764 1.23 1.726.616 2.415 1.415 2.415 2.737 0 1.295-.9 2.407-2.571 2.682z"
  })));
};
export default SvgDollarCircle;